import React from 'react';
import { HiChatBubbleBottomCenterText } from "react-icons/hi2";
import {FRONTEND_URL} from "../../config/constants";

import {isRead} from "../../helpers/notificationHelpers";

export default function ProjectMoreMessages ({key, notification, unreadCount})  {

    const handleClick = async() => {
        try{
            const projectId = notification.project?.id || notification.project_id;
            if (projectId) {
                const read = await isRead(projectId)
                if(read.message === "success"){
                    window.location.href = `/manage/project/${projectId}`;
                }
            }
        } catch (error){
            console.log(error);
        }
    }

    const projectName = notification.project?.name || notification.project?.project_name || 'Unknown Project';

    return (
        <>
            <div className={`w-full p-3 rounded flex ${unreadCount > 0 ? ' bg-green-100 dark:bg-green-900/30 ' : ' bg-white dark:bg-gray-800'}`}>
                <div tabIndex="0" aria-label="post icon" role="img"  className="focus:outline-none w-8 h-8 flex items-center text-gray-600 dark:text-gray-400"><HiChatBubbleBottomCenterText /></div>

                <div className="pl-3 cursor-pointer" onClick={handleClick} >
                    <p tabIndex="0" className="focus:outline-none text-sm text-gray-900 dark:text-gray-100">
                        You have {unreadCount} messages on {projectName}
                    </p>
                </div>

            </div>
        </>
    )
}